import { Component, ElementRef, forwardRef, HostBinding, Inject, Input, ViewEncapsulation } from '@angular/core';
import { select } from 'd3-selection';
import { zoomIdentity } from 'd3-zoom';

import { EcgChartComponent } from '../../ecg-chart/ecg-chart.component';
import { Zoomer } from '../../utils/zoomer';
import { Layout } from '../../layout/layout';
import { LayerViewModel } from '../../view-models/chart-viewmodel';


@Component({
    selector: '[layers-centering]',
    templateUrl: './layers-centering.component.html',
    styleUrls: ['./layers-centering.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class LayersCenteringComponent {
    // data members

    @Input()
    layers!: Array<LayerViewModel>;

    @Input()
    svgRoot!: any;

    visible: boolean = false;

    @Input()
    hideWhileCentering: boolean = true;

    @HostBinding('attr.transform')
    translate: string = '';

    private layersCentering;
    private chart;

    get isActiveLayerValid() {
        return this.ecgChart && this.ecgChart.chart && this.ecgChart.chart.activeLayer;
    }

    // constructor

    constructor(
        @Inject(forwardRef(() => EcgChartComponent)) private ecgChart: EcgChartComponent,
        private layout: Layout,
        private zoomer: Zoomer,
        private element: ElementRef,
    ) {
        this.layersCentering = select(this.element.nativeElement);
        this.chart = select(ecgChart.element.nativeElement);

        this.layout.layoutChange.subscribe((_) => {
            this.centerLayers();
        });

        ecgChart.fitChange.subscribe(() => {
            this.centerLayers();
        });
    }

    // public functions

    onResize() {
        this.centerLayers();
    }

    centerLayers() {
        if (this.hideWhileCentering) this.visible = false;

        setTimeout(() => {
            this.translateToCenter();
            this.fit();

            this.visible = true;
        });
    }

    private translateToCenter() {
        let chartBounds = {
            width: this.ecgChart.element.nativeElement.clientWidth,
            height: this.ecgChart.element.nativeElement.clientHeight,
        };

        let layersBounds = this.layersCentering.node().getBBox();

        let translateToCenterX = -layersBounds.x + (chartBounds.width / 2 - layersBounds.width / 2);
        let translateToCenterY = -layersBounds.y + (chartBounds.height / 2 - layersBounds.height / 2);

        this.translate =
            'translate(' + translateToCenterX + ', ' + Math.ceil((translateToCenterY / 5000) * 5000).toString() + ')';
    }

    private fit() {
        let width = this.ecgChart.element.nativeElement.clientWidth;
        let height = this.ecgChart.element.nativeElement.clientHeight;
        let layersBounds = this.layersCentering.node().getBBox();

        const bounds = layersBounds;
        const dx = bounds.width;
        const dy = bounds.height;
        const scale = 0.95 * Math.max(1, Math.min(10, 1 / Math.max(dx / width, dy / height)));

        let newCenter = [(scale * width) / 2 - width / 2, (scale * height) / 2 - height / 2];
        let translate = [-newCenter[0], -newCenter[1]];

        this.zoomer.transform(zoomIdentity.translate(translate[0], translate[1]).scale(scale));
    }
}
